// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--135nx","ChartWrapper":"ChartWrapper--rTt-d","Top":"Top--1FyDA","Bottom":"Bottom--1WvoR","Left":"Left--21Pai"};